import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-details-agency',
  templateUrl: './details-agency.component.html',
  styleUrl: './details-agency.component.scss'
})
export class DetailsAgencyComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DetailsAgencyComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {

  }
}